import { useTranslation } from "react-i18next";
import { ProfileCard } from "./ProfileCard";

// À remplir : préférences de cookies, conditions d'utilisation.
export const ProfilePrivacyTab = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto">
      <ProfileCard
        title={t("profile-privacy-empty-title")}
        subtitle={t("profile-privacy-empty-text")}
        icon="user-shield"
      />
    </div>
  );
};
